import { useState, useEffect } from 'react';
import type { Channel } from '../types/Channel';
import type { PlaylistItem } from '../types/PlaylistItem';
import { getMockPlayer } from '../services/mockPlayer';

interface UsePlayerReturn {
  loading: boolean;
  channel: Channel | null;
  playlist: PlaylistItem[];
  currentTrack: PlaylistItem | null;
  isPlaying: boolean;
  error: string | null;
}

export function usePlayer(slug: string | undefined): UsePlayerReturn {
  const [loading, setLoading] = useState(true);
  const [channel, setChannel] = useState<Channel | null>(null);
  const [playlist, setPlaylist] = useState<PlaylistItem[]>([]);
  const [currentTrack, setCurrentTrack] = useState<PlaylistItem | null>(null);
  const [isPlaying] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!slug) {
      setLoading(false);
      setError('Channel not found');
      return;
    }

    setLoading(true);
    setError(null);

    const timer = setTimeout(() => {
      const data = getMockPlayer(slug);
      if (!data) {
        setError('Channel not found');
        setLoading(false);
        return;
      }
      setChannel(data.channel);
      setPlaylist(data.playlist);
      setCurrentTrack(data.currentSong);
      setLoading(false);
    }, 600);

    return () => clearTimeout(timer);
  }, [slug]);

  return { loading, channel, playlist, currentTrack, isPlaying, error };
}